import { UserRole } from '../pages/users/interfaces'
import { isArray } from 'util'
import jMoment from 'moment-jalaali'

export type OrderTransportationType =
  | 'NONE'
  | 'ALOPEYK'
  | 'LINK_EXPRESS'
  | 'TAROFF'
enum dictionaryKey {
  common,
  order,
  TPL,
  tplStatus,
  driver,
  service,
  parcel,
  insurance,
  inventory,
  bundle,
  fleet,
  user,
  center,
  ticket,
  packaging
}

type DictionaryType = {
  [key in dictionaryKeyStrings]: {
    [key: string]: string
  }
}

type videosName = 'order' | 'parcel' | 'ticketing'

type dictionaryKeyStrings = keyof typeof dictionaryKey
const dictionary: DictionaryType = {
  common: {
    WEEKLY: 'هفتگی',
    MONTHLY: 'ماهانه',
    DAILY: 'روزانه',
    YEARLY: 'سالانه',
    BOX: 'کارتن',
    PALLET: 'پالت',
    BULK: 'فله',
    CHARGE: 'شارژ',
    INCREASE: 'افزایش',
    DECREASE: 'کاهش',
    SETTLE: 'تسویه',
    UPDATE_ORDER_STATUS: 'وبهوک تغییر وضعیت سفارش',
    UPDATE_PARCEL_STATUS: 'وبهوک تغییر وضعیت محموله',
    INVENTORY_CHANGE: 'وبهوک تغیر موجودی',
    COURIER: 'پیک',
    POST: 'پست',
    CHAPAR: 'چاپار',
    EXPRESS_POST: 'پست پیشتاز',
    SPECIAL_POST: 'پست سفارشی',
    VIP: 'ویژه',
    VVIP: 'ارسال فوری',
    PART_TIME: 'پاره وقت',
    FULL_TIME: 'تمام وقت',
    CAR: 'سواری',
    MOTORCYCLE: 'موتوری',
    PICKUPS: 'وانت',
    TRUCK: 'خاور',
    HEAVY_TRUCK: 'کامیون',
    AIRPLANE: 'هواپیما',
    DELIVER_IN_RONAD: 'تحویل در انبار',
    SAZITO: 'سازیتو',
    WP_PLUGIN: 'پلاگین',
    DIGIKALA: 'دیجی کالا',
    BASALAM: 'با سلام',
    RONAD: 'وب سرویس روناد',
    RONAD_PANEL: 'روناد',
    RONAD_BATCH: 'روناد',
    description: 'توضیحات',
    agentPhoneNumber: 'شماره مسئول حمل',
    FROM_CENTRE: 'روناد',
    NON: 'روناد'
  },
  order: {
    ARRIVED: 'به مقصد رسیده',
    BUNDLED: ' بسته‌بندی شده برای راننده',
    CANCELLED: 'لغو شده',
    DELIVERED_TO_POST: 'ارسال به پست',
    DELIVERING_TO_POST: 'در حال ارسال به پست',
    DELIVERED_TO_CENTER: 'تحویل به مرکز',
    SUPPLIED_IN_CENTER: 'تامین در مرکز',
    DELIVERED_TO_COURIER: 'تحویل پیک شد',
    PACKAGED: 'بسته‌بندی شده برای مشتری',
    PICKED: 'برداشته شده',
    DELIVERED: 'تحویل به مشتری',
    LOADED: 'تحویل پیک شد',
    NOT_DELIVERED: 'تحویل داده نشده',
    PROCESSING: 'در حال پردازش',
    PROCESSED: 'پردازش شده',
    ORDERED: 'ایجاد شده',
    RETURNED: 'بازگردانده شده',
    ASSIGNED: 'تخصیص شده',
    REGISTERED_IN_3PL: 'درحال ارسال',
    REGISTERING_IN_3PL: 'درحال ارسال',
    DELIVERING: 'درحال ارسال',
    DELIVERED_TO_3PL: 'درحال ارسال',
    DELIVERED_TO_3PL_COURIER: 'درحال ارسال',
    CANCELED_FROM_3PL: 'درحال ارسال',
    AWAITING_REVIEW: 'درحال ارسال',
    SUPPLYING: 'در انتظار تامین موجودی',
    DONE: 'ارسال به پست',
    QUEUE: 'آماده ارسال',
    DRAFT: 'ارسال نشده',
    true: 'باندل شده',
    false: 'باندل نشده',
    REQUESTED_TO_RETURN: 'درخواست بازگشت به انبار',
    RETURNED_TO_WAREHOUSE: 'بازگشت به انبار',
    REQUESTED_TO_RESEND: 'درخواست ارسال مجدد',
    SCANNED: 'اسکن شده',
    CONFIRMED: 'تایید شده',
    REGISTERED: 'ثبت در سیستم',
    AWAITING_PAYMENT: 'در انتظار پرداخت',
    CANCELED: 'کنسل شده'
  },
  TPL: {
    NONE: 'بدون 3PL',
    ALOPEYK: 'الوپیک',
    LINK_EXPRESS: 'لینک اکسپرس',
    TAROFF: 'تعارف',
    TAROFF_V2: 'تعارف',
    CHAPAR: 'چاپار',
    PETROEX: 'پتروکس',
    PISHRO_POST: 'پیشرو پست',
    SPEED: 'اسپید',
    DTSXP: 'دی تی اس',
    TAPIN_POST: 'تاپین',
    TAPIN_KETAB: 'تاپین کتاب',
    NEDEX: 'ندکس',
    RONAD: 'لجستیک',
    SNAPP: 'اسنپ',
    TAPSI: 'تپسی',
    KHANOOMI: 'خانومی',
    SNAPP_BOX: 'اسنپ باکس',
    ALOPEYK_BUSINESS: 'الوپیک بیزینس',
    PARTNER_LOGISTIC: 'ناوگان مشتری',
    RONAD_LOGISTIC: 'ناوگان روناد'
  },
  ticket: {
    OPEN: ' باز',
    CLOSED: 'بسته',
    ASSIGNEE_ANSWERED: 'پاسخ پشتیانی',
    PENDING: 'در انتظار پاسخ',
    OWNER_ANSWERED: 'در حال بررسی',
    NON: 'ناشناخته',
    LOW: 'کم',
    NORMAL: 'متوسط',
    HIGH: 'زیاد',
    CRITICAL: 'اضطراری',
    SUPPORT_OPEN: 'ایجاد شده',
    SUPPORT_PENDING: 'درحال بررسی',
    SUPPORT_ASSIGNEE_ANSWERED: 'پاسخ داده شده',
    SUPPORT_OWNER_ANSWERED: 'درحال بررسی',
    FFC_ASSIGNEE_ANSWERED: 'پاسخ داده شده',
    FFC_OWNER_ANSWERED: 'درحال بررسی',
    FFC_PENDING: 'در حال بررسی',
    PARTNER_PENDING: 'نیازمند بررسی',
    PARTNER_OPEN: 'نیازمند بررسی',
    PARTNER_ASSIGNEE_ANSWERED: 'درحال بررسی',
    PARTNER_OWNER_ANSWERED: 'نیازمند بررسی',
    SUPPORT_CLOSED: 'بسته شده',
    PARTNER_CLOSED: 'بسته شده',
    FFC_CLOSED: 'بسته شده'
  },
  tplStatus: {
    REJECTED_BY_3PL: 'رد شده توسط 3PL',
    REGISTERED_IN_3PL: 'ثبت شده در 3PL',
    SEARCHING_COURIER: 'جستجوی پیک',
    SEARCHING_COURIER_EXPIRED: 'جستجوی پیک منقضی شد',
    COURIER_ACCEPTED: 'پیک درخواست شما را پذیرفت',
    DELIVERED_TO_3PL: 'تحویل داده شده به 3PL ',
    DELIVERED_TO_3PL_COURIER: 'تحویل داده شده به پیک 3PL ',
    DELIVERED: 'تحویل داده شده',
    NOT_DELIVERED: 'تحویل داده نشده',
    CANCELLED: 'لغو شده',
    REQUESTED_TO_CANCEL: 'درخواست شده برای لغو',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    NONE: 'هیچکدام'
  },
  driver: {
    REGISTERED: 'ثبت نام',
    OFF: 'غیر فعال',
    ACTIVE: 'فعال',
    SUSPENDED: 'معلق',
    DELIVERED: 'سفیر شما رسیده است',
    PICKING: 'در مسیر تحویل گرفتن سفارش',
    SEARCHING: 'در حال جست و جوی سفیر',
    ACCEPTED: 'سفیر شما تحویل بسته را پذیرفت',
    EXPIRED: 'درخواست سفیر ، منقضی شد',
    DELIVERING: 'بسته شما در مسیر تحویل دادن سفارش است',
    CANCELLED: 'سفر شما لغو شد'
  },
  service: {
    1: 'پیشتاز',
    2: 'سفارشی',
    3: 'ویژه'
  },
  parcel: {
    1: 'پاکت پیشتاز',
    2: 'بسته پیشتاز',
    3: 'پاکت سفارشی',
    4: 'بسته سفارشی',
    5: 'مطبوع',
    6: 'کیسه M',
    10: 'امانت',
    SUBMITTED: 'ایجاد شده',
    SHIPPED: ' ارسال شده',
    DELIVERED: ' تخلیه شده',
    CANCELLED: ' لغو شده',
    ASSIGNED: 'اختصاص داده شده',
    RETURNING: 'ریجکت شده',
    ARRIVED: 'به مقصد رسیده',
    UNLOADING: 'در حال بارگذاری',
    UNLOADED: 'تخلیه شده',
    CONFLICTED: 'مغایرت',
    REGISTERED: 'رجیستر شده',
    LOCATED: 'جایگذاری شده',
    PICKED: 'برداشته شده',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    CHECKED: 'بسته‌بندی شده',
    RECEIPT_TO_WASTAGE: 'ورود به قرنطینه',
    RECEIPT_FROM_WASTAGE: 'خروج از قرنطینه',
    LESS_THAN_SUBMITTED: 'تعداد کم',
    PHYSICAL_CONFLICT: 'مشکل فیزیکی',
    RESOLVED_BY_RONAD: 'رفع مغایرت توسط روناد',
    MONTHLY_ECONOMIC_PICKUP: 'سراسری ماهانه',
    WEEKLY_ECONOMIC_PICKUP: 'هفتگی تهران',
    POSTED_BY_MYSELF: 'ارسال توسط خودم',
    PARCEL_FAST: 'پردازش سریع',
    PARCEL_BASIC: 'پردازش پایه'
  },
  insurance: {
    1: 'بیمه عادی',
    2: 'وجه نقد',
    3: 'اوراق و اسناد بانکی',
    4: 'بار انبوه',
    5: 'سایر'
  },
  inventory: {
    FROZEN: 'منجمد',
    FRUIT: 'میوه',
    GROCERY: 'خواربار',
    MEAT: 'گوشت',
    MASK: 'ماسک',
    PRODUCT: 'محصول',
    PICKED: 'برداشته شده',
    CHECKED: 'بررسی شده',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    REGISTERED: 'رجیستر شده',
    LOCATED: 'جایگذاری شده',
    NOT_LOCATED: 'جاگذاری نشده',
    INBOUND: 'ورودی',
    PURCHASE: 'سفارش',
    OUTBOUND: 'خروجی',
    CURRENTLY: 'موجودی فعلی',
    OTHER: 'نامشخص',
    null: 'نامشخص'
  },
  bundle: {
    ASSIGNED: 'اختصاص داده شده',
    CANCELLED: 'لغو شده',
    CREATED: 'بسته ایجاد شده',
    LOADED: 'بارگیری شده',
    PROCESS_FAILED: 'ناموفق',
    PROCESS_STARTED: 'راننده در مسیر مرکز',
    PROCESSED: 'راننده تحویل داده',
    VEHICLE_ARRIVED: 'ماشین به مرکز رسیده'
  },
  fleet: {
    PROPRIETARY: 'اختصاصی',
    THIRD_PARTY: 'عمومی',
    SUSPENDED: 'غیر فعال',
    ACTIVE: 'فعال'
  },
  user: {
    NONE: 'هیچکدام',
    RONAD_ADMIN: 'مدیر ارشد',
    PARTNER_ADMIN: 'ادمین شرکت',
    LOGISTICS_ADMIN: 'سرپرست لجستیک',
    WAREHOUSE_ADMIN: 'ادمین انبار',
    WAREHOUSE_OPERATOR: 'اپراتور انبار',
    WAREHOUSE_SUPERVISOR: 'سرپرست انبار',
    DRIVER: 'راننده',
    CENTER_ADMIN: 'ادمین مرکز',
    MARKETING_MANAGER: 'مدیر مارکتینگ',
    MARKETING_EXPERT: 'کارشناس مارکتینگ',
    OPERATIONS_MANAGER: 'مدیر عملیات',
    OPERATIONS_EXPERT: 'کارشناس عملیات',
    SUPPORT_MANAGER: 'مدیر پشتیبانی',
    SUPPORT_EXPERT: 'کارشناس پشتیبانی',
    AGENCY_ADMIN: 'نماینده',
    SELLER_ADMIN: 'ادمین فروشنده',
    FINANCIAL_SUPERVISOR: 'سرپرست مالی'
  },
  center: {
    ACTIVE: 'فعال',
    SUSPENDED: 'غیرفعال'
  },
  cod: {
    COD: 'در محل',
    ONLINE: 'آنلاین'
  },
  postPaid: {
    true: 'فعال',
    false: 'غیرفعال'
  },
  invoice: {
    CREATED: 'ایجاد شده',
    PAID: 'تسویه شده',
    NOT_PAID: 'تسویه نشده',
    CANCELED: 'لغو شده'
  },
  packaging: {
    CATALOG: 'بروشور',
    GIFT_PACK: 'پک هدیه',
    BRANDED_LABEL: 'برچسب',
    VISIT_CARD: 'کارت ویزیت'
  }
}
export const translate = (
  value: string,
  type: dictionaryKeyStrings = 'common'
) => {
  return dictionary[type][value] || value
}
export function translateParcelOrderStatus(value: any) {
  const status = {
    SUBMITTED: 'ایجاد شده',
    SHIPPED: ' ارسال شده',
    CANCELLED: ' لغو شده',
    RETURNING: 'ریجکت شده',
    ARRIVED: 'به مقصد رسیده',
    UNLOADING: 'درحال پردازش',
    UNLOADED: 'تخلیه شده',
    CONFLICTED: 'مغایرت',
    REGISTERED: 'رجیستر شده',
    LOCATED: 'جایگذاری شده',
    PICKED: 'برداشته شده',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    CHECKED: 'بسته‌بندی شده',
    BUNDLED: ' بسته‌بندی شده برای راننده',
    DELIVERED_TO_POST: 'ارسال به پست',
    DELIVERING_TO_POST: 'در حال ارسال به پست',
    DELIVERED_TO_CENTER: 'تحویل به مرکز',
    SUPPLIED_IN_CENTER: 'تامین در مرکز',
    DELIVERED_TO_COURIER: 'تحویل پیک شد',
    PACKAGED: 'بسته‌بندی شده برای مشتری',
    DELIVERED: 'تحویل به مشتری',
    LOADED: 'در حال تحویل',
    NOT_DELIVERED: 'تحویل داده نشده',
    PROCESSING: 'در حال پردازش',
    PROCESSED: 'پردازش شده',
    ORDERED: 'ایجاد شده',
    RETURNED: 'بازگردانده شده',
    ASSIGNED: 'تخصیص شده',
    REGISTERED_IN_3PL: 'ثبت در 3PL',
    REGISTERING_IN_3PL: 'در حال ثبت روی 3PL',
    DELIVERING: 'در حال تحویل',
    DELIVERED_TO_3PL: 'تحویل به 3PL',
    DELIVERED_TO_3PL_COURIER: 'تحویل به پیک 3PL',
    CANCELED_FROM_3PL: 'لغو از 3PL',
    AWAITING_REVIEW: 'نتیجه نامشخص',
    SUPPLYING: 'در انتظار تامین موجودی',
    DONE: 'جایگذاری شده',
    RECEIPT_TO_WASTAGE: 'ورود به قرنطینه',
    RECEIPT_FROM_WASTAGE: 'خروج از قرنطینه'
  }
  return status[value]
}
export function translateVideosName(value: videosName) {
  const Name = {
    '0_INTRODUCE': 'آشنایی',
    '1_PRODUCT': 'کالا',
    '2_PARCEL': 'محموله',
    '3_ORDER': 'سفارش',
    '4_PACKAGE': 'بسته‌بندی',
    '5_TICKETING': 'تیکتینگ',
    '6_FINANCIAL': 'مالی',
    '7_CONFIGURATION': 'تنظیمات'
  }
  return Name[value]
}
export function flattenObject(obj: { [key: string]: any }) {
  const toReturn = {} as { [key: string]: string }
  for (const i in obj) {
    if (!obj.hasOwnProperty(i) && i !== null) continue

    if (isArray(obj[i])) {
      // convert Array to string with ','
      obj[i] = obj[i].join(',')
    }
    if (typeof obj[i] == 'object' && obj[i] !== null) {
      const flatObject = flattenObject(obj[i])

      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue

        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = obj[i]
    }
  }
  return toReturn
}

export const packegeCounter = (packages: object[]) => {
  return packages.reduce((acc, curr) => {
    return acc + curr.count
  }, 0)
}

export const UserRoles: UserRole[] = [
  'RONAD_ADMIN',
  'MARKETING_MANAGER',
  'MARKETING_EXPERT',
  'OPERATIONS_MANAGER',
  'OPERATIONS_EXPERT',
  'SUPPORT_MANAGER',
  'SUPPORT_EXPERT',
  'WAREHOUSE_SUPERVISOR',
  'WAREHOUSE_ADMIN',
  'WAREHOUSE_OPERATOR',
  'PARTNER_ADMIN',
  'AGENCY_ADMIN',
  'CENTER_ADMIN',
  'SELLER_ADMIN',
  'DRIVER',
  'LOGISTICS_ADMIN',
  'FINANCIAL_SUPERVISOR'
]

export const checkHourisPast = (hour: number, day: string): boolean => {
  if (
    convertPersianDigit2English(jMoment().format('YYYY-MM-DD')) === day ||
    convertPersianDigit2English(jMoment().format('YYYY-MM-DD')) ===
      convertPersianDigit2English(jMoment(day).format('YYYY-MM-DD'))
  ) {
    return convertPersianDigit2English(jMoment().format('HH')) >= hour
  }
  if (
    (convertPersianDigit2English(
      jMoment().add(1, 'day').format('YYYY-MM-DD')
    ) === day ||
      convertPersianDigit2English(
        jMoment().add(1, 'day').format('YYYY-MM-DD')
      ) === convertPersianDigit2English(jMoment(day).format('YYYY-MM-DD'))) &&
    hour == 0
  ) {
    return convertPersianDigit2English(jMoment().format('HH')) >= 16
  }
  return false
}

export const checkDaysPast = (
  days: number,
  oldDeliveryDate: string,
  newDeliveryDate: string
) => {
  const oldDay = jMoment(oldDeliveryDate).add(days, 'day').jDate()
  const oldMonth = jMoment(oldDeliveryDate).add(days, 'day').jMonth()
  const newDay = jMoment(newDeliveryDate).jDate()
  const newMonth = jMoment(newDeliveryDate).jMonth()
  if (oldMonth === newMonth) {
    return newDay >= oldDay
  } else if (newMonth > oldMonth) {
    return true
  } else {
    return false
  }
}

export const disablePrevDateByHour = (hour: number) => {
  const today = new Date()
  if (today.getHours() >= hour) {
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)
    return dateFormater(tomorrow)
  } else {
    return dateFormater(today)
  }
}

export const dateFormater = (date: Date) => {
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${(
    '0' + date.getDate()
  ).slice(-2)}`
}

export const skipDateByDay = (date: any, day: number) => {
  const newDate = new Date(date)
  newDate.setDate(newDate.getDate() + day)

  return newDate
}

export const maxDate = (dates: Date[]) => {
  const max = dates[0] > dates[1] ? dates[0] : dates[1]
  return max
}

export function convertPersianDigit2English(string: any) {
  return string
    .replace(/[\u0660-\u0669]/g, (c: string) => {
      return c.charCodeAt(0) - 0x0660
    })
    .replace(/[\u06f0-\u06f9]/g, (c: string) => {
      return c.charCodeAt(0) - 0x06f0
    })
}

export function numberWithCommas(x: any) {
  return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function convertDatePersianToEnglish(date: any) {
  return date.replace(/[۰-۹]/g, (d: any) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
}

export const removeEmptyValueObject = (obj: any) => {
  Object.keys(obj).forEach((key) => {
    if (
      // todo: it must be on filter form
      typeof obj[key]?.contains === 'string' &&
      obj[key].contains.substring(0, 1) === '0' &&
      key === 'phoneNumber'
    ) {
      obj[key].contains = obj[key].contains.replace('0', '98')
    }
    if (obj[key] && typeof obj[key] === 'object' && obj[key].length !== 0) {
      removeEmptyValueObject(obj[key])
    }
    // recurse
    else if (obj[key] == null || obj[key] === '' || obj[key].length === 0)
      delete obj[key] // delete
  })

  return obj
}

export function uintToString(uintArray: number[]) {
  const encodedString = String.fromCharCode.apply(null, uintArray),
    decodedString = decodeURIComponent(escape(encodedString))
  return JSON.parse(decodedString)
}

export function formaterPhoneNumber(string: string | undefined) {
  if (string && String(string).includes('+98'))
    return String(string).replace('+98', '0')
  if (string && String(string).includes('+'))
    return String(string).replace('+', '0')
  return string
}

export function changePhoneNumberFormatTo98(string: string | undefined) {
  if (string?.startsWith('0')) {
    return '+98' + string.substring(1)
  }
  return string
}

export function checkMatchMedia(media: string) {
  return window.matchMedia(media).matches
}

export function fixNumbers(str: string) {
  const persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g
    ],
    arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
  for (let i: any = 0; i < 10; i++) {
    str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i)
  }
  return str.trim()
}

export function fixToPersianNumbers(str: string) {
  const englishNumbers = [
      /0/g,
      /1/g,
      /2/g,
      /3/g,
      /4/g,
      /5/g,
      /6/g,
      /7/g,
      /8/g,
      /9/g
    ],
    persianNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩']
  for (let i: any = 0; i < persianNumbers.length; i++) {
    str = str.replace(englishNumbers[i], persianNumbers[i])
  }
  return str.trim()
}

export function handleRedirectByRule(role: string) {
  switch (role) {
    case 'AGENCY_ADMIN':
      return (window.location.href = '/reports/current-orders')
    case 'CENTER_ADMIN':
      return (window.location.href = '/orders')
    case 'WAREHOUSE_SUPERVISOR':
      return (window.location.href = '/warehouses')
    case 'WAREHOUSE_ADMIN':
      return (window.location.href = '/warehouse-admin-orders')
    case 'WAREHOUSE_OPERATOR':
      return (window.location.href = '/parcels-warehouse-operator')
    case 'LOGISTICS_ADMIN':
      return (window.location.href = '/nonPost-orders')
    case 'SELLER_ADMIN':
      return (window.location.href = '/seller-orders')
    case 'EXCHANGE_ADMIN':
      return (window.location.href = '/bundles')
    default:
      return (window.location.href = '/orders')
  }
}

export function getCurrentTime() {
  const date = new Date()
  const time = `${date.getHours()}:${('0' + date.getMinutes()).slice(-2)}:00`

  return time
}

export function getVVIPTime() {
  const now = new Date()
  const then = new Date(now.getTime() + 45 * 60000)
  const time = `${then.getHours()}:${('0' + then.getMinutes()).slice(-2)}:00`

  return time
}

export function useQuery(locationHook: () => any) {
  return new URLSearchParams(locationHook().search)
}

export const handleErrorList = (errors: Array<any>) => {
  const errorList: Array<unknown> = []
  errors.map((el: any) => {
    el?.errorList.map((err: any) => {
      errorList.push({
        code: el?.code,
        text: err?.description,
        variantCode: err?.variantCode,
        productCode: err?.productCode
      })
    })
  })
  return errorList
}
